import { Grid, makeStyles, Paper, Typography, Backdrop } from "@material-ui/core";
import React, { useEffect, useState, useContext } from "react";
import Loader from "../../components/common/Loader";
import FormTipoIngrediente from "../../components/tipos-ingredientes/forms/FormTipoIngrediente";
import { AuthContext } from "../../context/AuthContextProvider";
import TiposIngredientesColumn from "../../components/tipos-ingredientes/columns/TiposIngredientesColumn";
import tiposIngredientesService from "../../api/tiposIngredientesService";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: "20px",
  },
  title: {
    marginBottom: "30px",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

const TiposIngredientes = () => {
  const { negocioActivo } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [tipoSelected, setTipoSelected] = useState(null);
  const [tiposIngredientes, setTiposIngredientes] = useState([]);
  const [crearNuevoTipoGlobal, setCrearNuevoTipoGlobal] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    tiposIngredientesService
      .getAll()
      .then((response) => {
        setTiposIngredientes(response.data);
        setLoading(false);
      })
      .catch((e) => console.log(e));
  };

  const onSubmitTipoIngredienteGlobal = (tipoIngrediente) => {
    setLoading(true);
    let body = {
      ...tipoIngrediente,
      minimo: Number(tipoIngrediente.minimo),
      maximo: Number(tipoIngrediente.maximo),
      ingredientes: tipoIngrediente.ingredientes.map((ing) => {
        return { ...ing, id: undefined, precio: !!ing ? Number(ing.precio) : 0 };
      }),
    };
    crearNuevoTipoGlobal
      ? tiposIngredientesService
          .createGlobal(body)
          .then((res) => {
            setTipoSelected(null);
            fetchData();
          })
          .catch((e) => console.log(e))
      : tiposIngredientesService
          .update({ ...body, id: undefined }, body.id)
          .then((res) => {
            setTipoSelected(null);
            fetchData();
          })
          .catch((e) => console.log(e));
  };

  const onEliminarTipoIngrediente = (tipoIngrediente) => {
    setLoading(true);
    tiposIngredientesService.delete(tipoIngrediente.id).then(() => {
      setTipoSelected(null);
      fetchData();
    });
  };

  const renderTipoSelectedColumn = () => {
    return (
      <Paper className={classes.columns}>
        {(tipoSelected || crearNuevoTipoGlobal) && (
          <FormTipoIngrediente
            negocioId={negocioActivo.id}
            onSubmit={onSubmitTipoIngredienteGlobal}
            tipoIngrediente={tipoSelected}
            onCancelar={() => {
              setTipoSelected(null);
              setCrearNuevoTipoGlobal(false);
            }}
            onEliminar={onEliminarTipoIngrediente}
          />
        )}
      </Paper>
    );
  };

  const onSelectTipoIngrediente = (tipo) => {
    setCrearNuevoTipoGlobal(false);
    setTipoSelected(tipo);
  };

  return (
    <div className={classes.root}>
      <Typography component="h1" variant="h5" className={classes.title}>
        Modificar Tipos de Ingredientes
      </Typography>
      <Grid container>
        <Grid item xs={12} sm={3}>
          <TiposIngredientesColumn
            onAgregarTipoIngredienteGlobal={() => {
              setTipoSelected(null);
              setCrearNuevoTipoGlobal(true);
            }}
            onSelectTipoIngrediente={onSelectTipoIngrediente}
            tipoSelected={tipoSelected}
            tiposIngredientes={tiposIngredientes}
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          {renderTipoSelectedColumn()}
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={loading}>
        <Loader />
      </Backdrop>
    </div>
  );
};

export default TiposIngredientes;
